import React from 'react';

import MenuItemMobile from './MenuItemMobile';
import { languageOptions } from './languages';
import { BodyText } from '../../StyledComponents';

function LanguageMenuListMobile(props) {
  const {
    language,
    onChange = () => {},
    ...restProps
  } = props;

  const items = languageOptions.map((lang) => (
    <MenuItemMobile
      {...restProps}
      key={lang.value}
      onClick={() => onChange(lang.value)}
      data-active={lang.value === language ? 1 : null}
    >
      <BodyText
        type="bodySecondary"
        isMobile
      >
        {lang.label}
      </BodyText>
    </MenuItemMobile>
  ));

  return (
    <React.Fragment>
      {items}
    </React.Fragment>
  )
}

export default React.memo(LanguageMenuListMobile);


// WEBPACK FOOTER //
// ./src/js/widgets/Header/LanguageSelector/LanguageMenuListMobile.js